<div class="modal-header">
    <h4 class="modal-title">{{title}}</h4>
    <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body" [formGroup]="form" *ngIf="!loading">
    <div class="row">
        <div class="col-md-12">
            <div class="row" *ngIf="!transfer">
                <div class="col-md-12">
                    <eris-platform-picker
                        [platforms]="availablePlatforms"
                        [selectedId]="form?.value?.targetPlatform"
                        (selectedChange)="onPlatformSelected($event)"
                        [buttonsPerRow]="5"
                        [groupOrder]="platformGroupOrder"
                        [itemDefaultOrder]="platformItemDefaultOrder">
                    </eris-platform-picker>
                </div>  
            </div>

            <div class="vertical-separator"></div>

            <!-- Common attributes -->
            <div class="row">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-12">
                                    <mat-form-field style="width: 100%;">
                                        <mat-label>Transfer name</mat-label>
                                        <input matInput [formControl]="form.controls.transferName"
                                            placeholder="Ex. TRN_..." (input)="onTransferNameChange()">
                                        <mat-error
                                            *ngIf="form.controls.transferName.errors && (form.controls.transferName.dirty || form.controls.transferName.touched)">Transfer
                                            name is required</mat-error>
                                    </mat-form-field>
                                </div>
                            </div>
                            <div class="vertical-separator"></div>
                            <div class="form-group row align-middle">
                                <div class="col-md-3 d-flex align-items-center">
                                    <mat-form-field>
                                        <mat-label>Scheduling</mat-label>
                                        <mat-select [formControl]="form.controls.schedulingId">
                                            <mat-option *ngFor="let audienceScheduling of audiencesSchedulings"
                                                [value]="audienceScheduling.id">{{audienceScheduling.description}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="form.controls.schedulingId.errors && (form.controls.schedulingId.dirty || form.controls.schedulingId.touched)">Scheduling
                                            is required</mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-3 d-flex align-items-center">
                                    <mat-form-field *ngIf="+form.controls.schedulingId.value > 1" style="display: inline-flex;">
                                        <mat-label>Scheduling end date</mat-label>
                                        <input matInput [matDatepicker]="picker"
                                            [formControl]="form.controls.schedulingEndDate"
                                            [value]="form.controls.schedulingEndDate.value">
                                        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                                        <mat-hint>DD/MM/YYYY</mat-hint>
                                        <mat-datepicker #picker></mat-datepicker>
                                    </mat-form-field>
                                </div>
                                <div class="col-md-2 d-flex align-items-center"></div>
                                <div class="col-md-2 d-flex align-items-center">
                                    <mat-checkbox *ngIf="!transfer" formControlName="createFile"
                                        (change)="updateValueAndValidity()">Create
                                        file</mat-checkbox>
                                </div>
                                <div class="col-md-2 d-flex align-items-center">
                                    <mat-checkbox *ngIf="!transfer && form.controls.createFile.value && 
                                        transfersService.isTransferFileActionAllowed(TransferFileAction.CreateAndSend, { targetPlatform: +form.controls.targetPlatform.value })"
                                        formControlName="sendAfterCreate"
                                        (change)="updateValueAndValidity()">Send after
                                        create</mat-checkbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="vertical-separator"></div>
            <!-- Platform specific attributes -->
            <div class="row" *ngIf="!transfer">
                <div class="col-md-12">
                    <wam-attributes-block
                        *ngIf="+form.controls.targetPlatform.value == targetPlatforms.WAMProxy"
                        [form]="form.controls.customSegmentAttributes"
                        [updateValueAndValidity]="updateValueAndValidity">
                    </wam-attributes-block>
                    <app-meta-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.Meta"
                        [form]="form.controls.metaAttributes" [erisAudienceName]="audience.name"
                        [updateValueAndValidity]="updateValueAndValidity">
                    </app-meta-attributes>
                    <app-amazon-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.Amazon"
                        [form]="form.controls.amazonAttributes" [erisAudienceName]="audience.name"
                        [updateValueAndValidity]="updateValueAndValidity">
                    </app-amazon-attributes>
                    <app-taptap-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.TapTap"
                        [form]="form.controls.tapTapAttributes" [erisAudienceName]="tapTapAudienceName"
                        [updateValueAndValidity]="updateValueAndValidity">
                    </app-taptap-attributes>
                    <app-xandr-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.Xandr"
                        [form]="form.controls.xandrAttributes" [erisSegmentName]="audience.name"
                        [updateValueAndValidity]="updateValueAndValidity">
                    </app-xandr-attributes>
                    <app-movistar-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.Movistar"
                        [form]="form.controls.movistarAttributes" [updateValueAndValidity]="updateValueAndValidity">
                    </app-movistar-attributes>
                    <app-a3media-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.A3Media"
                        [form]="form.controls.a3MediaAttributes" [erisAudienceName]="a3MediaAudienceName"
                        [updateValueAndValidity]="updateValueAndValidity">
                    </app-a3media-attributes>
                    <app-netflix-attributes 
                    *ngIf="+form.controls.targetPlatform.value == targetPlatforms.Netflix"
                    [loading]="netflixLoading">
                    </app-netflix-attributes>
                    <app-ttd-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.TheTradeDesk"
                        [form]="form.controls.ttdAttributes" [updateValueAndValidity]="updateValueAndValidity">
                    </app-ttd-attributes>
                    <app-tiktok-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.TikTok"
                        [form]="form.controls.tiktokAttributes" [updateValueAndValidity]="updateValueAndValidity">
                    </app-tiktok-attributes>
                    <app-dv360-attributes *ngIf="+form.controls.targetPlatform.value == targetPlatforms.DV360"
                        [form]="form.controls.dv360Attributes" [updateValueAndValidity]="updateValueAndValidity">
                    </app-dv360-attributes>
                </div>
            </div>
            <div class="vertical-separator" *ngIf="!transfer"></div>
            <div class="row" *ngIf="!transfer && availableIdentifiersTypesSelections?.length > 0">
                <div class="col-md-12">
                    <div class="card">
                        <div class="card-body">
                            <label>Select the identifiers for file:</label>
                            <div [formGroup]="form.controls.targetIdentifiers" class="form-group">
                                <ng-container *ngFor="let identifiersTypesSelection of availableIdentifiersTypesSelections">
                                    <mat-checkbox [formControlName]="identifiersTypes[identifiersTypesSelection.identifierTypeKey]"
                                        (change)="updateValueAndValidity()">{{identifiersTypes[identifiersTypesSelection.identifierTypeKey]}}
                                        ({{identifiersTypesSelection.count | number:'':'es'}} identifiers)</mat-checkbox>
                                    <br />
                                </ng-container>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onAccept()" [disabled]="form.invalid">Accept</button>
    <button type="button" class="btn btn-secondary" (click)="onDismiss()">Cancel</button>
</div>